import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import '../../content/css/HighlightTexts.css';
import HighlightTextBox from './HighlightTextBox';

export default class HighlightTexts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            highlights: [],
            updates: 0
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.highlights !== prevProps.highlights) {
            this.initialize();
        }

        if (this.state.highlights !== prevState.highlights) {
            this.update();
        }

        if (this.props.lastUpdate !== prevProps.lastUpdate) {
            this.initialize();
        }

        if (this.props.selectedHighlight !== prevProps.selectedHighlight && this.props.lastUpdate !== 0) {
            this.update(true);
        }
    }

    initialize() {
        var documentHtml = document.getElementById("main-document-view");
        var highlightTextRects = [...documentHtml.getElementsByClassName("highlight")];

        if (highlightTextRects === undefined || highlightTextRects.length === 0) {
            this.setState({ highlights: [], updates: 0 });
            return;
        }

        var parentTop = documentHtml.offsetTop;
        var parentHeight = documentHtml.offsetHeight;
        let scrollElement = document.querySelector("html");
        let scrollTop = scrollElement.scrollTop;

        var highlights = [];
        this.props.highlights.forEach((highlight, i) => {

            //Find correct highlight text rect element.
            var element = highlightTextRects.find(x => -1 < x.dataset.highlightId.indexOf(i.toString()));
            if (element === undefined) return;

            var boundingRect = element.getBoundingClientRect();
            var y = Math.min(Math.max(boundingRect.top - parentTop + scrollTop, 0), parentHeight);
            highlights.push({
                highlight,
                index: i,
                middle: y,
                isMinimized: this.props.selectedHighlight - 1 !== i
            });
        });

        this.setState({ highlights, updates: 0 });
    }

    update = (forceThrough = false) => {
        if (this.state.highlights === undefined || this.state.highlights.length === 0)
            return;

        //To stop infinite loops.
        if (!forceThrough && this.state.updates >= 5)
            return;

        let contentElement = document.getElementsByClassName("content")[0];
        let textBoxes = contentElement.getElementsByClassName("box");
        if (textBoxes === undefined || textBoxes.length === 0)
            return;

        var highlights = [];
        var didChange = false;

        this.state.highlights.forEach((h, i) => {
            var box = textBoxes[i];
            var height = box.offsetHeight;
            var top = Math.max(h.middle - height / 2, 0);
            var bottom = top + height;
            var isMinimized = this.props.selectedHighlight !== i;

            highlights.push({
                highlight: this.props.highlights[i],
                index: h.index,
                middle: h.middle,
                top,
                height: height,
                bottom,
                isMinimized
            });

            didChange = didChange || h.height !== height || h.isMinimized !== isMinimized;
        });

        if (!didChange) return;

        //Hide all non-selected text boxes.
        for (var i = 0; i < highlights.length; i++) {

            if (i !== this.props.selectedHighlight) {
                highlights[i].visibility = "hidden";  //ToDO: Här sätt visibiltity för boxen... Kom ihåg
            }
        }

        let updates = forceThrough ? 1 : this.state.updates + 1;
        this.setState({ highlights, updates });
    }

    getTextBoxes() {
        return this.state.highlights.map((h, i) => (
            <HighlightTextBox
                key={i}
                index={h.index}
                highlight={h.highlight}
                highlightsCount={this.state.highlights.length}
                top={h.top}
                visibility={h.visibility}
                isMinimized={h.isMinimized}
                isSelected={this.props.selectedHighlight === i}
                isAdmin={this.props.isAdmin}
                selectedHighlight={this.props.selectedHighlight}
                onDelete={this.props.onDelete}
                onNotesChange={this.props.onNotesChange}
                onSelectChange={this.props.onSelectChange}
            />
        ));
    }

    render() {
        return (
            <Row className="clause-info-list">
                {this.getTextBoxes()}
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Highlight/HighlightTexts.js